import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { LazyImage } from "@website/ui/lazy-image";
import { ListItem } from "@website/ui/list-item";
import { TransitionV2 } from "@website/ui/transition";
import { getChannel } from "@website/utils/channel/get-channel";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import LOGO from "@website/widget/header/assets/logo.png";
import LOGO_SNAPP from "@website/widget/header/assets/logo_snapp.svg";
import { useDrawer } from "@website/widget/header/components/drawer/drawer.hook";
import styles from "@website/widget/header/components/drawer/drawer.module.scss";
import { DrawerPropertiesType } from "@website/widget/header/components/drawer/drawer.types";
import { FC } from "react";

const alt_logo = replaceSnappTripBasedOnChannel("snapptrip");

export const Drawer: FC<DrawerPropertiesType> = (properties) => {
  const { services, onClose } = properties;
  const { transitionProperties } = useDrawer(properties);

  return (
    <TransitionV2 {...transitionProperties}>
      {(state) => (
        <div
          className={`${styles["container"]} ${
            state === "entering" || state === "entered" ? styles["open"] : null
          }`}
        >
          <div className={styles["header"]}>
            <Button
              EndIcon={<MaterialIcon name="arrow_forward" variant="outlined" />}
              aria-label="close"
              color="neutral"
              equalDimension
              onClick={onClose}
              size="small"
              variant="text"
            />
            <div className={styles["logo"]}>
              <a aria-label={alt_logo} href="/" itemScope>
                <LazyImage
                  alt={`${alt_logo} logo`}
                  height={78}
                  loading="eager"
                  src={getChannel() === "snapp-ir" ? LOGO_SNAPP.src : LOGO.src}
                  title={replaceSnappTripBasedOnChannel("اسنپ تریپ")}
                  width={137}
                />
              </a>
            </div>
          </div>
          <nav className={styles["list"]}>
            {services?.map((item) => (
              <a
                className={styles["list-item"]}
                href={item.url}
                key={item.title}
                onClick={onClose}
              >
                <ListItem
                  EndIcon={
                    <MaterialIcon name="chevron_left" variant="outlined" />
                  }
                  StartIcon={item.icon}
                  data-noindex="true"
                  title={item.title}
                />
              </a>
            ))}
          </nav>
        </div>
      )}
    </TransitionV2>
  );
};
